declare namespace $ {

	export class $shm_hitalama_resizer_side extends $rise_drag_view {
		display( ): string
		left( ): string
		right( ): string
		resize_side( ): string
		width( next?: number ): number
		width_px( ): string
		width_min( ): number
		width_max( ): number
		y( ): number
		style( ): ({ 
			'display': ReturnType< $shm_hitalama_resizer_side['display'] >,
			'left': ReturnType< $shm_hitalama_resizer_side['left'] >,
			'right': ReturnType< $shm_hitalama_resizer_side['right'] >,
		})  & ReturnType< $rise_drag_view['style'] >
	}
	
}

//# sourceMappingURL=side.view.tree.d.ts.map